export default class MockService {
    getSpices() {
        const spices = ['acide', 'soucre', 'amere', 'piquant'];
        return spices;
    }
}
